module.exports = __webpack_public_path__ + "static/media/DataDisclosure.a5b42fb2.png";